// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_reset.scss";
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_typography.scss";

import { bindSignup } from "../../../svelte/src/bindings/signup.js";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod";
import { initializeConfig } from "../src/general/config";
import { initializeTracking } from "../src/general/tracking";
import { initializeVisibilities } from "../src/general/visibilities";

bindTestPanel();
initializeVisibilities();
initializeConfig();
initializeTracking();

bindSignup();
